import { PortableText } from '@portabletext/react';
import Image from 'next/image';
import { useState } from 'react';
import { Col, Container, Pagination, Row } from 'react-bootstrap';
import { client } from '../../utils/GROQ';

import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { doctorInsight1 } from '../../assets/images';
import BottomImage from '../../components/bottomImage';

const Blog = (props) => {
  const router = useRouter();

  // **For the active topic**
  const [activeTopic, setActiveTopic] = useState('General');

  // ---- Pagination setup (simple) ----
  const pageSize = 9;
  const totalPages = Math.ceil(props.totalPosts / pageSize);
  const currentPage = router.query.pageNumber
    ? parseInt(router.query.pageNumber, 10)
    : 1;

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    router.push(
      {
        pathname: '/blog',
        query: { pageNumber: page },
      },
      undefined,
      { shallow: false }
    );
  };

  const renderPaginationItems = () => {
    const items = [];

    let start = currentPage - 2;
    let end = currentPage + 2;

    // Keep it within bounds
    if (start < 1) {
      start = 1;
      end = Math.min(3, totalPages);
    }
    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, totalPages - 2);
    }

    for (let page = start; page <= end; page++) {
      items.push(
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => goToPage(page)}
        >
          {page}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div>
      <Head>
        <title>Our Blogs - 24hrdoc</title>
        <meta
          name='description'
          content='Get health tips, medical insights, and telehealth updates on the 24hrdoc blog. Stay informed with expert advice on virtual care, treatments, and wellness.'
        />
        <meta
          property='og:image'
          content={
            'https://www.24hrdoc.com/_next/image?url=%2Fassets%2Ficons%2FLogoTransparent.png&w=256&q=75'
          }
        />
        <link rel='canonical' href='https://www.24hrdoc.com/blog' />
      </Head>

      {/* <div className='heroWrapper'>
        <div className='heroContent'>
          <h1 className='heroHeading'>Blog</h1>
          <p className='heroPara'>
            <span className='heroParaBlogSmll'>
              {' '}
              Explore the latest in telehealth, gain valuable health tips, and
              read about topics that impact modern healthcare. Our blog is your
              go-to resource for understanding how online healthcare can be
              tailored to fit your lifestyle, keeping you and your family
              informed and healthy.
            </span>
            <span className='heroParaBlogLg'>
              Explore the latest in telehealth, gain valuable health tips, and
              read about topics that impact modern
              <br /> healthcare. Our blog is your go-to resource for
              understanding how online healthcare can be tailored to fit your
              <br /> lifestyle, keeping you and your family informed and
              healthy.
            </span>
          </p>
        </div>
      </div> */}
      <section className='tw-w-full tw-py-8 lg:tw-py-16 tw-bg-[#fbfbfb]'>
        <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem] '>
          <div className='tw-flex tw-flex-col tw-gap-y-8 tw-w-full'>
            <h1 className='tw-m-0 tw-text-4xl lg:tw-text-5xl lg:tw-text-center'>
              Bl<span className='gradientText'>og</span>
            </h1>
            <p className='tw-m-0 lg:tw-text-center tw-text-[#5F5F5F]'>
              Explore the latest in telehealth, gain valuable health tips, and
              read about topics
              <br className='tw-hidden xl:tw-block' /> that impact modern
              healthcare. Our blog is your go-to resource for understanding how{' '}
              <br className='tw-hidden xl:tw-block' />
              online healthcare can be tailored to fit your lifestyle, keeping
              you and your family <br className='tw-hidden xl:tw-block' />{' '}
              informed and healthy.
            </p>
          </div>
        </div>
      </section>

      {/* The title Div */}
      <div className='browseByTopic'>
        <h2 className='browseByTopicHeading'>
          Browse by <span className='gradientText'>health topics</span>
        </h2>
        <div className='theBlogTopics'>
          {blogTopics.map((item) => (
            <div
              key={item.id}
              className={`${
                item.topic === activeTopic ? 'activeTopic' : 'theTopic'
              }`}
              onClick={() => setActiveTopic(item.topic)}
            >
              {item.topic}
            </div>
          ))}
        </div>
      </div>

      <Container fluid>
        <Row className=' rowBlogsNew px-0'>
          <Col className='px-0 d-flex flex-column mb-4'>
            <Row className=' gx-4 gy-4'>
              {props.posts &&
                props.posts.map((post) => (
                  <Col key={post._id} sm={4}>
                    <div className=' px-2 py-2 rounded-2 d-flex flex-column justify-content-between'>
                      <Link
                        href={{
                          pathname: `/blog/${post.slug.current}`,
                        }}
                      >
                        <div
                          className='position-relative'
                          style={{
                            overflow: 'hidden',
                            cursor: 'pointer',
                          }}
                        >
                          <Image
                            src={post?.imageUrl}
                            alt={post?.title}
                            layout='responsive'
                            objectFit='cover'
                            width={405}
                            height={280}
                            style={{ borderRadius: '0.5rem' }}
                          />
                        </div>
                      </Link>

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          rowGap: '0.75rem',
                          marginTop: '1.5rem',
                          marginBottom: '0.75rem',
                        }}
                      >
                        <div
                          style={{
                            color: '#195D9D',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            columnGap: '0.75rem',
                          }}
                        >
                          <span>Common Medical</span>
                          <span
                            style={{
                              color: '#0000005C',
                              width: '0.5px',
                              fontWeight: '400',
                            }}
                          >
                            |
                          </span>
                          <span>
                            {post?.publishedAt
                              ? new Date(post.publishedAt).toLocaleDateString(
                                  'en-US',
                                  {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  }
                                )
                              : getRandomBlogDate()}
                          </span>
                        </div>
                        <div>
                          <Link
                            href={{
                              pathname: `/blog/${post.slug.current}`,
                            }}
                          >
                            <h2
                              style={{ cursor: 'pointer' }}
                              className='postTitle'
                            >
                              {post?.title}
                            </h2>
                          </Link>
                          <div className='postBody'>
                            <PortableText
                              value={
                                post?.body?.length > 1
                                  ? post?.body?.[0]
                                  : post?.body
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className=' d-flex justify-content-between mt-2'></div>
                      <div>
                        <Link
                          href={{
                            pathname: `/blog/${post.slug.current}`,
                          }}
                        >
                          <button
                            className='theReadMoreButton'
                            style={{ backgroundColor: '#F5F2F1' }}
                          >
                            Read More
                          </button>
                        </Link>
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>

            {props.totalPosts > pageSize ? (
              <Pagination className='d-flex justify-content-center mt-5'>
                <Pagination.Prev
                  disabled={currentPage === 1}
                  onClick={() => goToPage(currentPage - 1)}
                />

                {renderPaginationItems()}

                <Pagination.Next
                  disabled={currentPage === totalPages}
                  onClick={() => goToPage(currentPage + 1)}
                />
              </Pagination>
            ) : null}
          </Col>
        </Row>
      </Container>

      <div className='doctorInsight'>
        <div className='doctorInsightInner'>
          <h2 className='browseByTopicHeading'>
            Our <span className='gradientText'>most viewed</span>
          </h2>

          <Container fluid className='px-lg-0'>
            <Row className='px-lg-0 g-5'>
              {props.mostViewed.map((item) => (
                <Col key={item.id} xs={12} xl={6} className=''>
                  <Row className='px-0 mx-0 doctorInsightPost'>
                    <Col className=' px-lg-0' xs='auto'>
                      <div>
                        <Link href={{ pathname: `/blog/${item.slug.current}` }}>
                          <Image
                            src={item.imageUrl}
                            alt='image'
                            quality={80}
                            width={240}
                            height={208}
                            style={{
                              borderRadius: '0.5rem',
                              cursor: 'pointer',
                            }}
                          />
                        </Link>
                      </div>
                    </Col>

                    <Col
                      xs={12}
                      md={6}
                      xl={6}
                      className='px-lg-0 d-flex flex-column justify-content-center lg-d-flex'
                    >
                      <div style={{ marginBottom: '1.25rem' }}>
                        <Link href={{ pathname: `/blog/${item.slug.current}` }}>
                          <h3
                            className='doctorInsightTitle'
                            style={{ cursor: 'pointer' }}
                          >
                            {item.title}
                          </h3>
                        </Link>

                        <div className='mostViewdCaption'>
                          <PortableText
                            value={
                              item?.body?.length > 1
                                ? item?.body?.[1]
                                : item?.body
                            }
                          />
                        </div>
                      </div>

                      <div>
                        <Link href={{ pathname: `/blog/${item.slug.current}` }}>
                          <button
                            className='theReadMoreButton'
                            style={{ cursor: 'pointer' }}
                          >
                            {' '}
                            Read More
                          </button>
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Col>
              ))}
            </Row>
          </Container>
        </div>
      </div>

      <BottomImage path={'/services'} />
    </div>
  );
};

export default Blog;

export async function getServerSideProps({ query }) {
  let pageSize = 9;
  let pageNumber = query.pageNumber ? parseInt(query.pageNumber, 10) : 1;
  let start = pageSize * pageNumber - pageSize || 0;
  let end = pageSize * pageNumber || pageSize;

  const posts = await client.fetch(
    `*[_type == "post" && !(_id in path("drafts.**"))] | order(_createdAt desc) { _id, "imageUrl": mainImage.asset->url,body,title,slug,publishedAt}[${start}...${end}]`
  );
  const totalPosts = await client.fetch(
    'count(*[_type == "post" && !(_id in path("drafts.**"))])'
  );
  const mostViewed = await client.fetch(
    '*[_type == "post" && !(_id in path("drafts.**"))] | order(views desc) {slug,title,"imageUrl": mainImage.asset->url,publishedAt,body}[0...6]'
  );

  return {
    props: { posts: posts, totalPosts: totalPosts, mostViewed: mostViewed },
  };
}

const blogTopics = [
  { id: 1, topic: `General` },
  { id: 2, topic: `Common Medical Condtions` },
  { id: 3, topic: `Men's Health` },
  { id: 4, topic: `Women's Health` },
  { id: 5, topic: `Mental Health` },
];

function getRandomBlogDate() {
  const today = new Date();
  const pastDate = new Date();

  // Move back by 12 months
  pastDate.setMonth(today.getMonth() - 12);

  // Generate a random timestamp between pastDate and today
  const randomTime =
    pastDate.getTime() + Math.random() * (today.getTime() - pastDate.getTime());
  const randomDate = new Date(randomTime);

  // Format the date to a readable format
  return randomDate.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
